import axios from 'axios';

const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const getPresignedUrlForReferenceUpload = (upload_task_id, primary_patient_id, content_type, media_extension) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/create_presigned_url_for_reference_upload`, {
            upload_task_id: upload_task_id,
            primary_patient_id: primary_patient_id,
            content_type: content_type,
            file_extension: media_extension,
        })
        .then((r) => {
            return r.data;
        });
};

export const getPresignedUrlForBookingVerificationUpload = (upload_task_id, booking_id, primary_patient_id, content_type, media_extension) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/create_presigned_url_for_booking_verification_upload`, {
            upload_task_id: upload_task_id,
            booking_id: booking_id,
            primary_patient_id: primary_patient_id,
            content_type: content_type,
            file_extension: media_extension,
        })
        .then((r) => {
            return r.data;
        });
};

export const getPresignedUrlForProcedureVerificationUpload = (consult_id, procedure_id, upload_task_id, primary_patient_id, content_type, media_extension) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/create_presigned_url_for_procedure_verification_upload`, {
            upload_task_id: upload_task_id,
            consult_id: consult_id,
            procedure_id: procedure_id,
            primary_patient_id: primary_patient_id,
            content_type: content_type,
            file_extension: media_extension,
        })
        .then((r) => {
            return r.data;
        });
};

export const createReferenceImageTask = (primary_patient_id) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/create_reference_image_task`, {
            primary_patient_id: primary_patient_id,
        })
        .then((r) => {
            return r.data.task_id;
        }).catch((e) => {
            throw "Unable to start refence image capture process. Please try again."
        });
};

export const createBookingVerificationTask = (primary_patient_id, booking_id) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/create_booking_verification_task`, {
            primary_patient_id: primary_patient_id,
            booking_id: booking_id,
        })
        .then((r) => {
            return r.data.task_id;
        }).catch((e) => {
            throw "Unable to start facial verification process for booking. Please try again."
        });
};

export const createProcedureVerificationTask = (primary_patient_id, consult_id, procedure_id) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/create_procedure_verification_task`, {
            primary_patient_id: primary_patient_id,
            consult_id: consult_id,
            procedure_id: procedure_id,
        })
        .then((r) => {
            return r.data.task_id;
        }).catch((e) => {
            throw "Unable to start facial verification process for procedure. Please try again."
        })
};

export const overrideFacialRecognitionTask = (facial_recognition_type, task_id) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/override_facial_recognition_task`, {
            facial_recognition_type: facial_recognition_type,
            task_id: task_id,
        })
        .then((r) => {
            return r.data.task_id;
        })
        .catch((err) => {
            console.log(err);
            if (err?.response?.status === 400) {
                throw err.response.data || 'Facial recognition task could not be overridden';
            } else {
                throw 'Facial recognition task could not be overridden';
            }
        });
};

export const markFacialRecognitionTaskUnverified = (facial_recognition_type, task_id) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/mark_facial_recognition_task_unverified`, {
            facial_recognition_type: facial_recognition_type,
            task_id: task_id,
        })
        .then((r) => {
            return r.data.task_id;
        })
        .catch((err) => {
            console.log(err);
            if (err?.response?.status === 400) {
                throw err.response.data || 'Invalid facial recognition type. Could not mark task as unverified.';
            } else {
                throw 'Invalid facial recognition type. Could not mark task as unverified.';
            }
        });
};

export const markFacialRecognitionTaskVerified = (facial_recognition_type, task_id) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/mark_facial_recognition_task_verified`, {
            facial_recognition_type: facial_recognition_type,
            task_id: task_id,
        })
        .then((r) => {
            return r.data.task_id;
        })
        .catch((err) => {
            console.log(err);
            if (err?.response?.status === 400) {
                throw err.response.data || 'Invalid facial recognition type. Could not mark task as unverified.';
            } else {
                throw 'Invalid facial recognition type. Could not mark task as unverified.';
            }
        });
};

export const markFacialRecognitionTaskError = (facial_recognition_type, task_id, error) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/mark_facial_recognition_task_error`, {
            facial_recognition_type: facial_recognition_type,
            task_id: task_id,
            error: error,
        })
        .then((r) => {
            return r.data.task_id;
        })
        .catch((err) => {
            console.log(err);
            if (err?.response?.status === 400) {
                throw err.response.data || 'Invalid facial recognition type. Could not mark task as error.';
            } else {
                throw 'Invalid facial recognition type. Could not mark task as error.';
            }
        });
};

export const patientReferenceExists = (primary_patient_id) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/patient_reference_exists`, {
            primary_patient_id: primary_patient_id,
        })
        .then((r) => {
            return r.data;
        });
};

export const retryFacialRecognitionVerification = (task_id) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/retry_facial_recognition_verification`, {
            task_id: task_id,
        })
        .then((r) => {
            return r.data;
        })
        .catch((err) => {
            console.log(err);
            if (err?.response?.status === 400) {
                throw err.response.data || 'Facial recognition verification could not be retried';
            } else {
                throw 'Facial recognition verification could not be retried';
            }
        });
};

export const getPatientReferenceUrl = (primary_patient_id) => {
    return axios
        .post(`${API_URL}/FacialRecognitionController/get_presigned_patient_reference_url`, {
            primary_patient_id: primary_patient_id,
        })
        .then((r) => {
            return r.data;
        })
        .catch((err) => {
            if (err?.response?.status === 404) {
                return null;
            }
        });
}

export const finalisePatientReference = (primary_patient_id) =>{
    return axios
        .post(`${API_URL}/FacialRecognitionController/finalise_patient_reference`, {
            primary_patient_id: primary_patient_id,
        })
        .then((r) => {
            return true
        })
        .catch((err) => {
            return false;
        })

}

export const dspRequiresFacialRecognition = (dsp_reference) =>{
    return axios
        .post(`${API_URL}/FacialRecognitionController/dsp_facial_recognition_requirement`, {
            dsp_reference: dsp_reference,
        })
        .then((r) => {
            return r.data
        })
}

export const markBookingVerification = (booking_id, approved, overridden) =>{
    return axios
        .post(`${API_URL}/FacialRecognitionController/mark_booking_verification`, {
            booking_id: booking_id,
            approved: approved,
            overridden: overridden,
        })
        .then((r) => {
            return r.data
        })
}

export const fetchPatientInformation = (primary_patient_id) =>{
return axios
    .post(`${API_URL}/FacialRecognitionController/get_patient_information`, {
        primary_patient_id: primary_patient_id,
    })
    .then((r) => r.data);
}
